import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CustomFieldFragment = (
  { __typename: 'CustomField' }
  & Pick<Types.CustomField, 'id' | 'name' | 'type'>
  & { display: (
    { __typename: 'CustomField_Display' }
    & Pick<Types.CustomField_Display, 'cardFront'>
  ), options?: Types.Maybe<Array<(
    { __typename: 'CustomField_Option' }
    & Pick<Types.CustomField_Option, 'id' | 'color'>
    & { value: (
      { __typename: 'CustomField_Option_Value' }
      & Pick<Types.CustomField_Option_Value, 'text'>
    ) }
  )>> }
);

export const CustomFieldFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'display' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cardFront' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCustomFieldFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<CustomFieldFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCustomFieldFragmentResult
  extends Omit<Apollo.UseFragmentResult<CustomFieldFragment>, 'data'> {
  data?: CustomFieldFragment;
}

export const useCustomFieldFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCustomFieldFragmentOptions): UseCustomFieldFragmentResult => {
  const result = Apollo.useFragment<CustomFieldFragment>({
    ...options,
    fragment: CustomFieldFragmentDoc,
    fragmentName: 'CustomField',
    from: {
      __typename: 'CustomField',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CustomFieldFragment };
};
